/* eslint-disable */

import React from 'react';
import { Progress } from 'rsuite';
import moment from 'moment';

const StoreStockCard = ({ item }) => {
	const { stockDetails, skuName, unit, productImages, variantName } = item;

	const currentStock = stockDetails?.qty || '0';
	const maxStock = stockDetails?.maxStock || currentStock;
	const currentNum =
		typeof currentStock === 'string'
			? parseFloat(currentStock.split(' ')[0]) || 0
			: Number(currentStock) || 0;
	const isZero = currentNum <= 0;
	const expiryDate =
		stockDetails?.expiryDate && stockDetails?.qty?.split(' ')[0] > 0
			? moment(stockDetails.expiryDate).format("Do MMM'YY")
			: null;

	// Calculate percentage
	const percentage =
		(maxStock?.split && maxStock?.split(' ')[0]) > 0
			? Math.min(
					100,
					(currentStock.split(' ')[0] / maxStock.split(' ')[0]) * 100
			  )
			: 0;
	// Determine bar color based on percentage (similar to ModernNode or custom logic)
	// Image: Use productImages[0] or a placeholder
	const imageUrl =
		productImages?.[0] || 'https://placehold.co/50x50?text=Product';

	const getBarColor = (p) => {
		if (p < 30) return '#ff4d4f'; // Red
		if (p < 70) return '#faad14'; // Orange
		return '#52c41a'; // Green
	};

	const barColor = getBarColor(percentage);

	return (
		<div
			className={`bg-white rounded-lg p-2 shadow-sm border border-gray-100 flex flex-col gap-1 w-full ${
				isZero ? 'opacity-60' : ''
			}`}
		>
			{/* Title */}
			<h4
				className='text-gray-700 font-medium text-xs truncate'
				title={skuName}
			>
				{skuName} ( {variantName} )
			</h4>

			{/* Content Row: Image + Progress */}
			<div className='flex items-center gap-2'>
				{/* Image */}
				<div className='w-10 h-10 flex-shrink-0 bg-gray-100 rounded-md overflow-hidden'>
					<img
						src={imageUrl}
						alt={skuName}
						className='w-full h-full object-cover'
						style={
							isZero
								? { filter: 'grayscale(100%)', opacity: 0.5 }
								: undefined
						}
					/>
				</div>

				{/* Progress Bar Area */}
				<div className='flex-1 flex flex-col justify-center'>
					<div className='flex items-center gap-2'>
						<div className='flex-1 h-3 bg-gray-200 rounded-full overflow-hidden'>
							<div
								className='h-full rounded-full'
								style={{
									width: `${percentage}%`,
									backgroundColor: barColor,
								}}
							></div>
						</div>
						<span className='text-xs font-semibold text-gray-800'>
							{percentage.toFixed(0)}%
						</span>
					</div>
				</div>
			</div>

			{/* Footer Row: Count + Expiry */}
			<div className='flex justify-between items-center text-[10px] mt-1'>
				<span className='text-gray-600 font-medium'>
					{currentStock}/{maxStock ?? currentStock}
				</span>
				{expiryDate && <span className='text-red-500 font-medium'>
					Use By: {expiryDate}
				</span>}
			</div>
		</div>
	);
};

export default StoreStockCard;
